import { useGeekStorage } from './useGeekStorage';

export type MarketingParam = string | undefined;

export interface useMarketingParamsResult {
  utmSource?: MarketingParam;
  utmMedium?: MarketingParam;
  utmTerm?: MarketingParam;
  utmCampaign?: MarketingParam;
  fromReferral?: MarketingParam;
  firstReferer?: MarketingParam;
  deviceType?: MarketingParam;
  slugPosition?: MarketingParam;
}

const transformParam = (
  param: string | string[] | undefined
): string | undefined => {
  if (param) {
    if (typeof param === 'object') return param.join();
    if (typeof param === 'string') return param || undefined;
  }

  return undefined;
};

export const useMarketingParams = (): useMarketingParamsResult => {
  const [geekStorage] = useGeekStorage();

  const {
    utmSource,
    utmMedium,
    utmTerm,
    utmCampaign,
    fromReferral,
    firstReferer,
    deviceType,
    slugPosition,
  } = geekStorage || {};

  return {
    utmSource: transformParam(utmSource),
    utmMedium: transformParam(utmMedium),
    utmTerm: transformParam(utmTerm),
    utmCampaign: transformParam(utmCampaign),
    fromReferral: transformParam(fromReferral),
    firstReferer: transformParam(firstReferer),
    deviceType: transformParam(deviceType),
    slugPosition: transformParam(slugPosition),
  };
};
